@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';
@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.subheader {
  font-size: 12px;
  font-weight: 500;
}

.radio-button-section {
  display: flex;
  margin-top: -8px;

  .radio-item:first-child {
    padding-right: 24px;
  }
}

.adyen-error {
  font-weight: 700;
  color: var(--error--message--text-color--1);
}

.payment-container {
  min-width: 370px;
}

.fsui-wrapper {
  gap: 32px;
}

.loader {
  min-height: 450px;
}

.left {
  > section {
    padding: 0;
  }
}

.right {
  section {
    // this prevents stupid jiggle from clicking on inputs because of underlying border changes
    width: 100%;
  }

  input {
    margin: 0;
  }
}

.left,
.right {
  display: flex;
  flex-direction: column;
  width: 100%;

  .spacer {
    margin: 12px 0;
  }
}

.tax-identifier-full-width {
  width: 100%;
}

.pickup-wrapper {
  padding: 0 @space-16;
  margin-bottom: @space-16;
}

.billing-info {
  padding: 0 @space-16;
  margin-bottom: @space-32;

  .address-dropdown {
    right: @space-36;
  }
}

.payment-method-header-padding {
  padding: 0 @space-16;
}

.payment-method-dropdown-padding {
  padding: 0 @space-16;
}

.tax-identifier-wrapper {
  > div {
    padding: 0 @space-16;
  }

  svg {
    color: var(--gray-637381);
  }
}

.tax-identifier-section {
  padding: @space-16;
  margin: @space-16;
  margin-top: 0;
  background-color: var(--grey-100);
  border: 1px solid var(--blue-600);
  border-radius: 8px;
}
